<template>
  <v-scale-transition>
    <wide-panel
      :title="title"
    >
      <v-toolbar flat>
        <v-menu
          v-model="monthMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="month"
              label="Select Month"
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
              style="max-width: 180px"
            />
          </template>

          <v-date-picker
            v-model="month"
            type="month"
            @input="monthMenu = false"
          />
        </v-menu>
        <v-select
          v-model="selectedWeek"
          :items="weekOptions"
          label="Select Week"
          item-text="label"
          item-value="value"
          style="max-width: 300px"
        />
        <v-spacer />
        <v-autocomplete
          v-if="signageAdmin"
          v-model="location"
          :items="locationItems"
          label="Select or type location"
          item-text="location"
          item-value="code"
          prepend-icon="mdi-city"
          return-object
        >
          <template #item="data">
            <v-list-tile-content>
              <v-list-tile-title>{{ data.item.location }}, {{ data.item.leadDealer }} </v-list-tile-title>
              <!-- <v-list-tile-sub-title>{{ data.item.leadDealer }}, {{ data.item.pic }}, {{ data.item.contact }}</v-list-tile-sub-title> -->
            </v-list-tile-content>
          </template>
        </v-autocomplete>
      </v-toolbar>
      <v-subheader>Activations</v-subheader>
      <v-sheet>
        <v-btn
          absolute
          dark
          fab
          small
          top
          right
          color="light-green"
          :disabled="signageAdmin && !location"
          @click="exportTracking('activation')"
        >
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-sheet>
      <v-data-table
        :headers="activationHeaders"
        :items="activations"
        :expand="expand"
        :loading="loading"
        item-key="day"
        class="elevation-1"
      >
        <template #items="props">
          <!-- ✅ Day -->
          <td class="text-xs-center">
            {{ props.item.day }}
          </td>

          <!-- ✅ Dynamic plans -->
          <td
            v-for="plan in dynamicPlans"
            :key="plan"
            class="text-xs-center"
          >
            {{ props.item[plan] }}
          </td>

          <!-- ✅ Total -->
          <td class="text-xs-right primary">
            {{ props.item.total }}
          </td>
        </template>
        <template #footer>
          <tr>
            <td class="text-xs-right">
              Sub-total:
            </td>
            <td
              v-for="plan in dynamicPlans"
              :key="plan"
              class="text-xs-center primary--text"
            >
              {{ totals[plan] }}
            </td>
            <td class="text-xs-right primary">
              {{ totalActivation }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-subheader>Reloads</v-subheader>
      <v-sheet>
        <v-btn
          absolute
          dark
          fab
          small
          top
          right
          color="light-green"
          :disabled="signageAdmin && !location"
          @click="exportTracking('reload')"
        >
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-sheet>
      <v-data-table
        :headers="reloadHeaders"
        :items="reloads"
        :expand="expand"
        :loading="loading"
        item-key="day"
        class="elevation-1"
      >
        <template #items="props">
          <tr
            :active="props.selected"
            @click="props.expanded = !props.expanded"
          >
            <td class="text-xs-center">
              {{ props.item.day }}
            </td>
            <td class="text-xs-center primary">
              {{ props.item.total }}
            </td>
          </tr>
        </template>
        <template #expand="props">
          <v-sheet color="grey">
            <v-container>
              <v-layout row>
                <v-flex x12>
                  <v-data-table
                    :headers="detailReloadHeaders"
                    :items="props.item.items"
                    item-key="dealer"
                    class="elevation-1"
                  >
                    <template #items="dealerProps">
                      <tr>
                        <td class="text-xs-left">
                          {{ dealerProps.item.dealer }}
                        </td>
                        <td class="text-xs-center primary">
                          {{ dealerProps.item.reload }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-sheet>
        </template>
        <template #footer>
          <tr>
            <td class="text-xs-right">
              Total:
            </td>
            <td class="text-xs-center primary">
              {{ Number(totalReload).toFixed(2) }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <!-- <v-subheader>Recruitments</v-subheader>
      <v-sheet>
        <v-btn
          absolute
          dark
          fab
          small
          top
          right
          color="light-green"
          @click="exportTracking(recruitments)"
        >
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-sheet>
      <v-data-table
        :headers="recruitmentHeaders"
        :items="recruitments"
        :expand="expand"
        :loading="loading"
        item-key="day"
        class="elevation-1"
      >
        <template #items="props">
          <tr
            :active="props.selected"
            @click="props.expanded = !props.expanded"
          >
            <td class="text-xs-center">
              {{ props.item.day }}
            </td>
            <td class="text-xs-center primary">
              {{ props.item.total }}
            </td>
          </tr>
        </template>
        <template #expand="props">
          <v-sheet color="grey">
            <v-container>
              <v-layout row>
                <v-flex x12>
                  <v-data-table
                    :headers="detailRecruitmentHeaders"
                    :items="props.item.items"
                    item-key="dealer"
                    class="elevation-1"
                  >
                    <template #items="dealerProps">
                      <tr>
                        <td class="text-xs-left">
                          {{ dealerProps.item.dealer }}
                        </td>
                        <td class="text-xs-center primary">
                          {{ dealerProps.item.recruitment }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-sheet>
        </template>
        <template #footer>
          <tr>
            <td class="text-xs-right">
              Total:
            </td>
            <td class="text-xs-center primary">
              {{ totalRecruitment }}
            </td>
          </tr>
        </template>
      </v-data-table> -->
    </wide-panel>
  </v-scale-transition>
</template>

<script>
import { DateTime } from 'luxon'
import { createGetParams } from '@/rest'
import security from '@/security'
import * as XLSX from 'xlsx'

export default {
  components: {
    WidePanel: () => import(/* webpackChunkName: "widePanel" */ '@/components/WidePanel'),
  },
  data () {
    return {
      month: DateTime.local().setZone('Asia/Kuala_Lumpur').toFormat('yyyy-LL'),
      today: DateTime.local().setZone('Asia/Kuala_Lumpur').toFormat('yyyy-LL-dd'),
      thisMonth: DateTime.local().setZone('Asia/Kuala_Lumpur').toFormat('yyyy-LL'),
      expand: false,
      monthMenu: false,
      loading: false,
      title: 'Track Weekly',
      location: null,
      selectedWeek: null,
      weekOptions: [],
      dates: [],
      dateMenu: false,
      locations: [],
      allLocationsData: [],
      activationHeaders: [],
      activations: [],
      reloads: [],
      recruitments: [],
      dynamicPlans: [],
      totals: [],
      reloadHeaders: [
        {
          text: 'Week',
          align: 'center',
          sortable: true,
          value: 'week',
        },
        {
          text: 'Total',
          align: 'center',
          sortable: true,
          value: 'total',
        },
      ],
      detailReloadHeaders: [
        {
          text: 'Dealer',
          align: 'left',
          sortable: true,
          value: 'dealer',
        },
        {
          text: 'Reload',
          align: 'center',
          sortable: true,
          value: 'reload',
        },
      ],
      recruitmentHeaders: [
        {
          text: 'Day',
          align: 'center',
          sortable: true,
          value: 'day',
        },
        {
          text: 'Total',
          align: 'center',
          sortable: true,
          value: 'total',
        },
      ],
      detailRecruitmentHeaders: [
        {
          text: 'Dealer',
          align: 'left',
          sortable: true,
          value: 'dealer',
        },
        {
          text: 'Recruitment',
          align: 'center',
          sortable: true,
          value: 'recruitment',
        },
      ],
      totalActivation: 0,
      totalReload: 0,
      totalRecruitment: 0,
    }
  },
  created: function () {
    this.generateWeeks()
    !this.signageAdmin && this.getSignageTracking(this.thisMonth)
    this.signageAdmin && this.getSignageLocations()
  },
  computed: {
    signageAdmin () {
      const properties = security.me.getProperties()
      let admin = false

      properties.forEach(property => {
        if (property.name === 'dashboard.signage' && property.value === 'admin') {
          admin = true
        }
      })

      return admin
    },
    locationItems () {
      return [
        { location: 'All Location', code: 'all', leadDealer: 'All Dealers' },
        ...this.locations,
      ]
    },
  },
  watch: {
    location: function (location) {
      this.getSignageTracking(this.month, location.code)
    },
    selectedWeek (week) {
      if (!this.location) {
        alert('Please select location first')
        return
      }

      if (week) {
        this.getSignageTracking(null, this.location.code)
      }
    },
    month () {
      this.generateWeeks()
      this.selectedWeek = null // reset selection
    },
  },
  methods: {

    generateWeeks () {
      const weeks = []

      const startOfMonth = DateTime.fromFormat(this.month, 'yyyy-LL').startOf('month')
      const endOfMonth = startOfMonth.endOf('month')

      let current = startOfMonth

      // 🔥 FIRST WEEK (1st → first Sunday OR month end)
      let firstEnd = current.endOf('week')

      if (firstEnd > endOfMonth) {
        firstEnd = endOfMonth
      }

      weeks.push({
        label: `Week 1 (${current.toFormat('dd LLL')} - ${firstEnd.toFormat('dd LLL')})`,
        value: {
          from: current.toFormat('yyyy-LL-dd'),
          to: firstEnd.toFormat('yyyy-LL-dd'),
        },
      })

      // 🔥 NEXT weeks
      current = firstEnd.plus({ days: 1 }) // move to next day

      let weekCount = 2

      while (current <= endOfMonth) {
        let end = current.plus({ days: 6 })

        if (end > endOfMonth) {
          end = endOfMonth
        }

        weeks.push({
          label: `Week ${weekCount} (${current.toFormat('dd LLL')} - ${end.toFormat('dd LLL')})`,
          value: {
            from: current.toFormat('yyyy-LL-dd'),
            to: end.toFormat('yyyy-LL-dd'),
          },
        })

        current = end.plus({ days: 1 })
        weekCount++
      }

      this.weekOptions = weeks
    },

    getSignageTracking: async function (month, code) {
      if (!this.selectedWeek) return

      const params = code
        ? createGetParams({
          from: this.selectedWeek.from,
          to: this.selectedWeek.to,
          code,
          mode: 'weekly',
        })
        : createGetParams({
          from: this.selectedWeek.from,
          to: this.selectedWeek.to,
          mode: 'weekly',
        })
      this.loading = true
      this.resetTotals()

      try {
        const response = await this.$rest.get('getSignageTracking.php', params)

        if (code === 'all') {
          // ✅ All Location: response.data IS the array of location blocks
          // (each block already carries its own activations/reloads/
          // recruitments), not a flat list of day-rows. Kept separate for
          // the export and the on-screen table is left empty (it's built
          // for single-location day-rows). Only dynamicPlans is derived
          // here, so export headers still line up with the plan columns.
          this.allLocationsData = response.data || []

          const sampleLocation = this.allLocationsData[0]
          const sampleRow = sampleLocation && sampleLocation.activations && sampleLocation.activations[0]

          if (sampleRow) {
            this.dynamicPlans = Object.keys(sampleRow).filter(key =>
              !['day', 'items', 'total'].includes(key),
            )
            this.activationHeaders = [
              { text: 'Day', value: 'day' },
              ...this.dynamicPlans.map(plan => ({
                text: plan,
                value: plan,
              })),
              { text: 'Total', value: 'total' },
            ]
          }

          this.loading = false
          return
        }

        const activations = response.data.activations

        // ✅ STEP 1: build dynamic plans
        if (activations.length > 0) {
          const sample = activations[0]

          this.dynamicPlans = Object.keys(sample).filter(key =>
            !['day', 'items', 'total'].includes(key),
          )

          // ✅ STEP 2: build headers dynamically
          this.activationHeaders = [
            { text: 'Day', value: 'day' },
            ...this.dynamicPlans.map(plan => ({
              text: plan,
              value: plan,
            })),
            { text: 'Total', value: 'total' },
          ]
        }

        // ✅ STEP 3: calculate totals dynamically
        this.totals = {}
        this.totalActivation = 0

        activations.forEach(activation => {
          this.dynamicPlans.forEach(plan => {
            this.totals[plan] = (this.totals[plan] || 0) + (activation[plan] || 0)
          })

          this.totalActivation += activation.total
        })

        // keep existing
        response.data.reloads.forEach(reload => {
          this.totalReload += reload.total * 1
        })

        response.data.recruitments.forEach(recruitment => {
          this.totalRecruitment += recruitment.total
        })

        this.activations = activations
        this.reloads = response.data.reloads
        this.recruitments = response.data.recruitments

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    resetTotals: function () {
      this.activations = this.reloads = this.recruitments = []
      this.allLocationsData = []
      this.dynamicPlans = []
      this.totals = {}
      this.totalActivation = this.totalReload = this.totalRecruitment = 0
    },
    getSignageLocations: async function () {
      const params = createGetParams({ list: true })
      try {
        const response = await this.$rest.get('getSignageLocations.php', params)
        this.locations = response.data
      } catch (error) {
        console.log(error)
      }
    },
    exportTracking (type) {
      if (this.location && this.location.code === 'all') {
        this.exportAllLocationsTracking(type)
        return
      }

      const data = []
      let headers = []
      let rows = []

      // ✅ ACTIVATION
      if (type === 'activation') {
        rows = this.activations
        headers = ['Day', ...this.dynamicPlans, 'Total']

        rows.forEach(obj => {
          data.push([
            obj.day,
            ...this.dynamicPlans.map(plan => obj[plan] || 0),
            obj.total,
          ])
        })
      }

      // ✅ RELOAD
      if (type === 'reload') {
        rows = this.reloads
        headers = ['Day', 'Total']

        rows.forEach(obj => {
          data.push([
            obj.day,
            obj.total,
          ])
        })
      }

      data.unshift(headers)

      // 🔥 USE leadDealer
      const dealerId = this.location?.leadDealer || 'ALL'

      // 🔥 MODE
      const mode = this.selectedWeek ? 'weekly' : 'monthly'

      // 🔥 MONTH
      const monthLabel = this.month

      // 🔥 WEEK LABEL
      let weekLabel = ''
      if (this.selectedWeek) {
        const label = this.weekOptions.find(
          w => w.value.from === this.selectedWeek.from,
        )?.label

        const match = label?.match(/Week\s(\d+)/)
        weekLabel = match ? `week${match[1]}` : 'week'
      }

      // 🔥 FINAL FILE NAME
      let fileName = ''

      if (mode === 'monthly') {
        fileName = `${type}_monthly_${monthLabel}_${dealerId}.xlsx`
      } else {
        fileName = `${type}_weekly_${monthLabel}_${weekLabel}_${dealerId}.xlsx`
      }

      const ws = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(wb, ws, 'Tracking')
      XLSX.writeFile(wb, fileName)
    },
    exportAllLocationsTracking (type) {
      const blocks = this.allLocationsData || []

      if (blocks.length === 0) {
        return
      }

      const data = []

      if (type === 'activation') {
        data.push(['No.', 'Company Name', ...this.dynamicPlans, 'Total'])

        const grand = {}
        this.dynamicPlans.forEach(plan => { grand[plan] = 0 })
        grand.total = 0

        blocks.forEach((block, idx) => {
          const totals = {}
          this.dynamicPlans.forEach(plan => { totals[plan] = 0 })
          let total = 0

          ;(block.activations || []).forEach(day => {
            this.dynamicPlans.forEach(plan => {
              totals[plan] += day[plan] || 0
            })
            total += day.total || 0
          })

          data.push([
            idx + 1,
            block.location,
            ...this.dynamicPlans.map(plan => totals[plan]),
            total,
          ])

          this.dynamicPlans.forEach(plan => { grand[plan] += totals[plan] })
          grand.total += total
        })

        data.push(['', 'TOTAL', ...this.dynamicPlans.map(plan => grand[plan]), grand.total])
      } else {
        // reload — one row per location, total reload
        data.push(['No.', 'Company Name', 'Total Reload'])

        let grandTotal = 0

        blocks.forEach((block, idx) => {
          const total = (block.reloads || []).reduce((sum, day) => sum + (parseFloat(day.total) || 0), 0)
          const rounded = Math.round(total * 100) / 100

          data.push([idx + 1, block.location, rounded])
          grandTotal += rounded
        })

        data.push(['', 'TOTAL', Math.round(grandTotal * 100) / 100])
      }

      const ws = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Summary')

      const monthLabel = this.month

      let weekLabel = ''
      if (this.selectedWeek) {
        const label = this.weekOptions.find(
          w => w.value.from === this.selectedWeek.from,
        )?.label

        const match = label?.match(/Week\s(\d+)/)
        weekLabel = match ? `week${match[1]}` : 'week'
      }

      const fileName = this.selectedWeek
        ? `${type}_weekly_${monthLabel}_${weekLabel}_ALL.xlsx`
        : `${type}_monthly_${monthLabel}_ALL.xlsx`

      XLSX.writeFile(wb, fileName)
    },
  },
}
</script>
